import { render, staticRenderFns } from "./MarcacaoForm.vue?vue&type=template&id=a3edf95e&scoped=true&"
import script from "./MarcacaoForm.vue?vue&type=script&lang=js&"
export * from "./MarcacaoForm.vue?vue&type=script&lang=js&"
import style0 from "./MarcacaoForm.vue?vue&type=style&index=0&id=a3edf95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3edf95e",
  null
  
)

export default component.exports